<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="商家企业微信CorpID" prop="subCorpId">
          <div class="style">
            <el-input v-model="ruleForm.subCorpId" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">
            可填写与商家主体一致且已认证的企业微信CorpID；审核通过后，系统将为商家开通企业微信专区的自有交易权限，并完成商家商户号与该CorpID的绑定。
          </p>
        </el-form-item>
        <el-form-item class="style" label="企业微信页面截图" prop="weworkPics">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.weworkPics && ruleForm.weworkPics.length > 4 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return weworkPicsSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="style"></div>
              <p class="labels-tips">请提供展示商品/服务的页面截图/设计稿（最多5张）</p>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      ruleForm: {
        subCorpId: '',
        weworkPics: [],
      },
      rules: {
        subCorpId: [{ required: true, message: '请输入商家企业微信CorpID', trigger: ['blur', 'change'] }],
        weworkPics: [{ required: true, message: '请上传企业微信页面截图', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.businessDataVO) {
          this.ruleForm = JSON.parse(JSON.stringify(data.businessDataVO));
          let weworkPicsList = data.businessDataVO.weworkPics.split(',');
          this.imgList = weworkPicsList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    weworkPicsSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.weworkPics.push(file.response.data.url);
      console.log(this.ruleForm.weworkPics);
    },
    handleRemove(file, fileList) {
      this.setImgurl(fileList);
    },
    setImgurl(fileList) {
      const result = [];
      for (let item of fileList) {
        console.log(item);
        item.size
          ? result.push({
              url: item.response.data,
            })
          : result.push({
              url: item.url,
            });
      }
      this.ruleForm.weworkPics = result;
    },
    // 验证表单
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
</style>
